<template>
	<div class="c-form-text">
		<input
			:type="type"
			:placeholder="placeholder"
			:value="modelValue"
			class="c-form-text__input"
			:class="{
				[`c-form-text__input--${type}`]: type !== 'text',
			}"
			v-bind="$attrs"
			@input="($event) => $emit('update:modelValue', $event.target.value)"
		/>

		<button
			v-if="type === 'search'"
			type="submit"
			class="absolute right-[0px] w-[40px] h-[40px] p-[12px] transition-transform duration-300 hover:scale-110"
			aria-label="Søg"
			@click="($event) => onSubmit?.($event)"
		>
			<SvgIconSearch class="w-full h-full" />
		</button>
	</div>
</template>

<script setup>
import SvgIconSearch from '~/assets/svgs/icon-search.svg';

const emit = defineEmits(['update:modelValue']);
const props = defineProps({
	type: {
		type: String,
		default: 'text',
	},
	placeholder: {
		type: String,
		default: null,
	},
	modelValue: {
		type: String,
		default: '',
	},

	// Actions
	onSubmit: {
		type: Function,
		default: null,
	},
});
</script>

<script>
export default {
	inheritAttrs: false,
};
</script>

<style lang="postcss">
.c-form-text {
	@apply relative flex items-center w-auto h-auto text-white;
}
.c-form-text__input {
	@apply w-full h-[40px] px-[16px] py-[8px] rounded-[3px] bg-navy border-none placeholder-[rgb(117,117,117)];

	&:hover {
		@apply bg-navy-dark;
	}
	&:focus {
		@apply bg-navy-dark outline-none;
	}
}
.c-form-text__input--search {
	@apply pr-[40px];
}
</style>
